
const styles = theme => ({
  container: theme.container,
  hero: {
    backgroundColor: '#19426C',
    padding: '30px 0 60px 0',
    backgroundImage: 'url(assets/bg-contrail.png)',
    backgroundSize: '50%',
    backgroundPositionX: 'right',
    backgroundRepeat: 'no-repeat',
    backgroundPositionY: '45%',
    position: 'relative',
  },
  heading: {
    color: '#FFFFFF',
    fontSize: '2.3em',
    margin: '0px',
    gap: '10px',
    '& span': {
      fontWeight: 'normal',
    },
  },
  logo: {
    width: '75px',
    height: 'auto',
  },
  tabsContainer: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  tabs: {
    backgroundColor: '#EAEAEA',
    display: 'flex',
    justifyContent: 'center',
    gap: '5px',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
  },
  tab: {
    backgroundColor: '#EAEAEA',
    padding: '10px 20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
    '& a': {
      color: '#414141',
      fontWeight: 'bold',
      fontSize: '1em',
      paddingLeft: '8px',
      textDecoration: 'none',
    },
    '& svg': {
      stroke: '#414141',
    },
    '&:first-child': {
      borderTopLeftRadius: '20px',
    },
    '&:nth-child(2)': {
      borderTopRightRadius: '20px',
    },
    '&.active': {
      backgroundColor: '#009845',
      '& svg': {
        stroke: '#FFFFFF',
      },
      '& a': {
        color: '#FFFFFF',
      },
    },
  },

  '@media (max-width: 870px)': {
    hero: {
      padding: '30px 0 70px 0',
    },
    // heading: {
    //   color: '#FFFFFF',
    //   fontSize: '1.9em',
    // },
    tab: {
      padding: '10px',
      '& a': {
        fontSize: '0.9em',
      },
    },
  },
});

export default styles;
